<template>
  <div class="license-container">
    <a class="link resource" :href="license.resUrl">
      <span>{{ license.resDescription }}</span>
    </a>
    by
    <a class="link" :href="license.authorUrl">
      <span>{{ license.author }}</span>
    </a>
    is licensed under
    <a class="link" :href="license.licenseUrl">
      <span>{{ license.licenseName }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "License",
  props: {
    license: Object,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.license-container {
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 3px;
  border: 3px solid hsl(0, 0%, 70%);
  background: hsl(0, 0%, 95%);
}
.resource span {
  display: block;
  word-break: break-all;
}
.link {
  text-align: center;
  align-self: center;
}
</style>
